import { render, staticRenderFns } from "./TargetCalculation.vue?vue&type=template&id=0aca48c2&scoped=true&"
import script from "./TargetCalculation.vue?vue&type=script&lang=ts&"
export * from "./TargetCalculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca48c2",
  null
  
)

export default component.exports